import React, { useState, useRef, useEffect } from "react";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Box from "@mui/material/Box";

// import "./login.css";
import "./login1.css";
import "../NavBar/index.css"
import Logo from "../NavBar/Asset/New_Assert/ESO_Logo.png";
import { FaEye, FaEyeSlash } from "react-icons/fa";
import GoogleLogo from "./Asset/google.png";
import AppleLogo from "./Asset/apple-logo.png";
import LoginImage from "./Asset/On_Board/login.gif";
import RegisterImage from "./Asset/On_Board/signup.gif";
import axios from "axios";
import Loader from "../NavBar/CommonLoader";
import { useSelector } from "react-redux";

import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useNavigate, useLocation } from "react-router-dom";
import { useDispatch } from "react-redux";
import { SetUserToken } from "../../Store/UserTokenSlice";
import { SetUserSubscription } from "../../Store/SubscriptionSlice";
import { SetUserFirstTimeLogin } from "../../Store/FirstTimeLoginSlice";
import { SetAuthToken } from "../../Store/ApiAuthKey";
import { useGoogleLogin } from "@react-oauth/google";
import GoogleIcon from '@mui/icons-material/Google';

import AppleLogin from "react-apple-login";
import AppleIcon from "@mui/icons-material/Apple";
import { jwtDecode } from "jwt-decode";
import { Helmet } from "react-helmet";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import Button from "@mui/material/Button";
import { RiHome2Fill } from "react-icons/ri";
import { CommonErrorAlert } from "../../Commonalert/commonErrorAlert";
import { SetDomainHeader } from "../../Store/DomainData";
import PhoneInput from "react-phone-input-2";
import BusinessMobile from "../NavBar/LoginDetail/businessmobile";
import ESOLogo from "../NavBar/Asset/New_Assert/ESO_Logo.png"
// import downloadImg from "./download.png";
// import sliderImg from "./slider.svg";
import downloadImg from "../NavBar/Asset/small-logo.png";
import sliderImg from "../NavBar/Asset/slider.svg";
import UserActivityTracker from "../../hooks/userActivityTracker";


function Registration() {


  const location = useLocation();
  const [apiopen, setapiOpen] = React.useState(false);
  const [apierrorMsg, setapierrorMsg] = useState();
  const strongPasswordRegex =
    /^(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/;
  function testPasswordStrength(password) {
    return strongPasswordRegex.test(password);
  }
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [formData, setFormData] = useState({
    emailPhone: "",
    password: "",
    emailPhonelgn: "",
    passwordlgn: "",
    mobile: "",
    business: "",
  });
  const esodata = useSelector((state) => state);
  const ApiToken = esodata.apiauthkey.value;
  const [loading, setLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [showPasswordreg, setShowPasswordreg] = useState(false);
  const [showCPasswordreg, setShowCPasswordreg] = useState(false);
  const [showPasswordlgn, setShowPasswordlgn] = useState(false);
  const [RememberMe, SetRememberMe] = useState(false);
  const [AcceptMe, SetAcceptMe] = useState(false);
  const [appledatavalue, Setappledatavalue] = useState(1);
  const [mobileErr, setMobileErr] = useState(null);

  const [errors, setErrors] = useState({
    emailPhone: "",
    password: "",
    emailPhonelgn: "",
    passwordlgn: "",
  });
  const fullnameRef = useRef(null);
  const emailPhoneRef = useRef(null);
  const passwordRef = useRef(null);
  const usernameRef = useRef(null);
  const confirmpasswordRef = useRef(null);
  const mobileRef = useRef(null);
  const businessRef = useRef(null);
  const sign = require("jwt-encode");
  const emailPhonelgnRef = useRef(null);
  const passwordlgnRef = useRef(null);
  const SmthandleChangelgn = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
    setErrors({
      ...errors,
      [name]: "",
    });
  };
  const SmthandleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
    setErrors({
      ...errors,
      [name]: "",
    });
  };

  const handlePhoneChange = (e, data) => {
    var { name, value } = { name: 'mobile', value: e };
    var errValue = null;

    const number = value.slice(data.dialCode.length);
    // const format = data.format.split(' ').join('');
    const format = data.format.split(/[()\-\+\s]+/).filter(Boolean).join('');

    if (format.length !== (data.dialCode + number).length) {
      errValue = 'Please enter the valid Phone Number';
    } else if (value === '' || number === '') {
      errValue = 'Please enter the Phone Number';
    } else {
      errValue = null;
    }

    setFormData(({
      ...formData,
      [name]: data.dialCode + '-' + number,
    }));
    setMobileErr(errValue);
  };


  const [AppleId, SetAppleId] = useState("kavitha@egrovesys.com");


  const apihandleClose = () => {
    setapiOpen(false);
  };


  const appleResponse = async (e) => {
    if (appledatavalue == 1) {
      Setappledatavalue(2);
      if (!e.user) {
        const idToken = jwtDecode(e.authorization?.id_token);
        setLoading(true);
        try {
          var datas = {
            email: idToken.email,
            type: "apple",
          };
          const jwt_datas = sign(datas, "VdM1t3n0NiD_Qsawq7ZX");
          const response = await axios
            .post(
              `${process.env.REACT_APP_API_URL}accounts/save_social_login_data/`,
              { data: jwt_datas }
            )
            .catch((error) => {
              setLoading(false);
              if (
                error?.response?.status == 599 ||
                error?.response?.status == 500 ||
                error?.response?.status == 400 ||
                error?.response?.status == 404
              ) {
                setapiOpen(true);
                setapierrorMsg(error?.response?.data?.error);
              } else if (error?.code == "ERR_NETWORK") {
                navigate("/login-errorpages");
              }
            });
          if (response?.data?.token) {
            dispatch(SetUserToken({ eso_user_token: response.data.token }));
            dispatch(
              SetAuthToken({ eso_auth_token: "Token " + response.data.token })
            );
            if (response.data.is_onboarding_completed === true)
              window.location.href = `${process.env.REACT_APP_DOMAIN}`;
            else
              window.location.href = `${process.env.REACT_APP_DOMAIN}Userdata`;
          }
        } catch (err) {
          setLoading(false);
          toast.error(err.response.data.error, {
            position: "top-center",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
          });
        }
        setLoading(false);
      } else {
        setLoading(true);
        try {
          var datas = {
            name: e.user.name.firstName + e.user.name.lastName,
            email: e.user.email,
            type: "apple",
          };
          const jwt_datas = sign(datas, "VdM1t3n0NiD_Qsawq7ZX");
          const response = await axios
            .post(
              `${process.env.REACT_APP_API_URL}accounts/save_social_login_data/`,
              { data: jwt_datas }
            )
            .catch((error) => {
              setLoading(false);
              if (
                error?.response?.status == 599 ||
                error?.response?.status == 500 ||
                error?.response?.status == 400 ||
                error?.response?.status == 404
              ) {
                setapiOpen(true);
                setapierrorMsg(error?.response?.data?.error);
              } else if (error?.code == "ERR_NETWORK") {
                navigate("/login-errorpages");
              }
            });
          if (response?.data?.token) {
            dispatch(SetUserToken({ eso_user_token: response.data.token }));
            dispatch(
              SetAuthToken({ eso_auth_token: "Token " + response.data.token })
            );
            if (response.data.is_onboarding_completed === true)
              window.location.href = `${process.env.REACT_APP_DOMAIN}`;
            else
              window.location.href = `${process.env.REACT_APP_DOMAIN}Userdata`;
          }
        } catch (err) {
          setLoading(false);
          toast.error(err.response.data.error, {
            position: "top-center",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
          });
        }
        setLoading(false);
      }
    }
  };
  const handleTogglePasswordreg = () => {
    setShowPasswordreg(!showPasswordreg);
  };
  const handlecTogglePasswordreg = () => {
    setShowCPasswordreg(!showCPasswordreg);
  };
  const handleTogglePasswordlgn = () => {
    setShowPasswordlgn(!showPasswordlgn);
  };
  const handleSubmit = async (e) => {
    e.preventDefault();
    console.log('formData', formData);
    const { emailaddress, password, confirmpassword, username, fullname, mobile, business } =
      formData;
    const phoneNumberRegex = /^[0-9]{10}$/;
    const emailRegex = /^[a-zA-Z0-9._-]+@[a-zA-Z][a-zA-Z0-9.-]*\.[a-zA-Z]{2,}$/;
    const newErrors = {};
    if (!emailaddress || emailaddress.length === 0) {
      newErrors.emailaddress = "Please enter your Email address";
      emailPhoneRef.current?.focus();
    } else if (!emailRegex.test(emailaddress)) {
      newErrors.emailaddress = "Invalid Email Address";
      emailPhoneRef.current?.focus();
    }
    if (!password) {
      newErrors.password = "Please enter your Password";
      passwordRef.current?.focus();
    }
    if (password) {
      if (testPasswordStrength(password) === false) {
        newErrors.password =
          "Password does not meet the criteria. It should contain at least one uppercase letter, one digit, and one special character (@, $, !, %, *, ?, &), and be at least 8 characters long";
        passwordRef.current?.focus();
      }
    }
    if (!confirmpassword) {
      newErrors.Confirmpassword = "Please enter Confirm Password";
      confirmpasswordRef.current?.focus();
    }
    if (
      confirmpassword &&
      password &&
      testPasswordStrength(password) !== false
    ) {
      if (confirmpassword != password)
        newErrors.Confirmpassword =
          "Password and Confirm password should be same";
      confirmpasswordRef.current?.focus();
    }
    if (!fullname) {
      newErrors.fullname = "Please enter your Full Name";
      fullnameRef.current?.focus();
    }
    if (!mobile || mobileErr) {
      const mobileErrs = !mobile ? 'Please enter your Phone Number' : mobileErr;
      setMobileErr(mobileErrs);
      // mobileRef.current.focus();
    }
    if (!business) {
      newErrors.business = "Please enter your Business Name";
      businessRef.current?.focus();
    }
    if (AcceptMe === false) {
      newErrors.acceptme = "Please accept Terms and Conditions";
    }
    setErrors(newErrors);
    if (newErrors.emailPhone) {
      emailPhoneRef.current?.focus();
    } else if (newErrors.password) {
      passwordRef.current?.focus();
    } else if (newErrors.username) {
      usernameRef.current?.focus();
    } else if (newErrors.fullname) {
      fullnameRef.current?.focus();
    } else if (newErrors.mobile) {
      mobileRef.current.focus();
    } else if (newErrors.business) {
      businessRef.current?.focus();
    }
    if (isObjectEmpty(newErrors) && !mobileErr) {
      setLoading(true);
      try {
        const Response = await axios
          .post(
            `${process.env.REACT_APP_API_URL}accounts/register/`,
            {
              username: emailaddress,
              password: password,
              email: emailaddress,
              name: fullname,
              phone_no: mobile,
              business_name: business
            },
            {
              headers: {
                Authorization: `${ApiToken}`,
              },
            }
          )
          .catch((error) => {
            setLoading(false);
            if (
              error?.response?.status == 599 ||
              error?.response?.status == 500 ||
              error?.response?.status == 400 ||
              error?.response?.status == 404
            ) {
              setapiOpen(true);
              setapierrorMsg(error?.response?.data?.error);
            } else if (error?.code == "ERR_NETWORK") {
              navigate("/login-errorpages");
            }
          });
        if (
          Response?.data?.status === "sucess" &&
          Response?.data?.is_email_verified === true
        ) {
          var inputElement = document.querySelector('[name="fullname"]');
          if (inputElement !== null) {
            inputElement.value = "";
          }

          var inputElement = document.querySelector('[name="emailaddress"]');
          if (inputElement !== null) {
            inputElement.value = "";
          }

          var inputElement = document.querySelector('[name="password"]');
          if (inputElement !== null) {
            inputElement.value = "";
          }
          tab1ref.current.click();
          toast.success('You have successfully registered!. Please Login', {
            position: "top-center",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
          });
          setLoading(false);
          // setFormData({});
        } else {
          await TriggerEmailOtp(Response.data.token);
          localStorage.setItem("verify_register_token", Response.data.token);
          navigate("/email-verification?verification=register");
        }
      } catch (err) {
        setLoading(false);
        if (err) {
          if (err.response) {
            if (err.response.data) {
              toast.error(err.response.data.error, {
                position: "top-center",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "light",
              });
            }
          }
        }
        console.log(err);
      }
    }
  };

  function isObjectEmpty(obj) {
    for (var key in obj) {
      if (obj.hasOwnProperty(key)) {
        return false;
      }
    }
    return true;
  }
  const loginSubmit = async (e) => {
    e.preventDefault();
    const { emailPhonelgn, passwordlgn } = formData;
    const phoneNumberRegex = /^[0-9]{10}$/;
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    // const newErrors = {};
    // if (!emailPhonelgn || emailPhonelgn.length === 0) {
    //   newErrors.emailPhonelgn = "Please enter your Email addresss";
    //   emailPhonelgnRef.current.focus();
    // }
    // if (!passwordlgn) {
    //   newErrors.passwordlgn = "Please enter your Password";
    //   passwordlgnRef.current.focus();
    // }
    // setErrors(newErrors);
    // if (newErrors.emailPhonelgn) {
    //   emailPhonelgnRef.current.focus();
    // } else if (newErrors.passwordlgn) {
    //   passwordlgnRef.current.focus();
    // }

    const newErrors = {};
    if (!emailPhonelgn || emailPhonelgn.length === 0) {
      newErrors.emailPhonelgn = "Please enter your Email address";
    }

    if (!passwordlgn || passwordlgn.length === 0) {
      newErrors.passwordlgn = "Please enter your Password";
    }

    setErrors(newErrors);

    if (newErrors.emailPhonelgn) {
      emailPhonelgnRef.current?.focus();
    } else if (newErrors.passwordlgn) {
      passwordlgnRef.current?.focus();
    }
    if (Object.keys(newErrors).length > 0) return;


    if (isObjectEmpty(newErrors)) {
      setLoading(true);
      try {
        if (RememberMe === true) {
          localStorage.setItem("logincookieemail", emailPhonelgn);
          localStorage.setItem("logincookiepass", passwordlgn);
          localStorage.setItem("logincookiestatus", RememberMe);
        } else {
          localStorage.setItem("logincookieemail", "");
          localStorage.setItem("logincookiepass", "");
          localStorage.setItem("logincookiestatus", "");
        }
        var Response = await axios
          .post(
            `${process.env.REACT_APP_API_URL}accounts/login/`,
            {
              username: emailPhonelgn,
              password: passwordlgn,
              remember_me: RememberMe,
            },
            {
              headers: {
                Authorization: `${ApiToken}`,
              },
            }
          )
          .catch((error) => {
            setLoading(false);
            if (
              error?.response?.status == 599 ||
              error?.response?.status == 500 ||
              error?.response?.status == 400 ||
              error?.response?.status == 404
            ) {
              setapiOpen(true);
              setapierrorMsg(error?.response?.data?.error);
            } else if (error?.code == "ERR_NETWORK") {
              navigate("/login-errorpages");
            }
          });
        if (Response?.data) {
          // const domainList = await axios.get(
          //   `${process.env.REACT_APP_API_URL}domain/get_user_domains/`, {
          //   headers: {
          //     Authorization: "Token " + Response.data.token,
          //   },
          // }
          // )
          // localStorage.setItem('header_selected', domainList?.data[0]?.id);
          // dispatch(SetDomainHeader({ header_selected: domainList?.data[0]?.id }));
          if (
            Response?.data?.success &&
            Response?.data?.is_email_verified === true &&
            Response?.data?.subscription_expired === false
          ) {
            if (Response?.data?.success === "Successfully logged in") {
              dispatch(SetUserToken({ eso_user_token: Response.data.token }));
              dispatch(
                SetAuthToken({ eso_auth_token: "Token " + Response.data.token })
              );
              dispatch(
                SetUserSubscription({
                  eso_user_subscription: Response.data.subscription_expired,
                })
              );
              dispatch(
                SetUserFirstTimeLogin({
                  eso_user_first_time_login: Response.data.first_time_login,
                })
              );
              setLoading(false);
              // setFormData({});

              window.location.href = `${process.env.REACT_APP_DOMAIN}`;
              // navigate(process.env.REACT_APP_DOMAIN);
            }
          } else if (Response?.data?.is_email_verified === false) {
            await TriggerEmailOtp(Response.data.token);

            localStorage.setItem("verify_register_token", Response.data.token);
            navigate('/email-verification?verification=login');
          } else if (Response?.data?.subscription_expired === true) {
            dispatch(SetUserToken({ eso_user_token: Response.data.token }));
            dispatch(
              SetAuthToken({ eso_auth_token: "Token " + Response.data.token })
            );
            dispatch(
              SetUserSubscription({
                eso_user_subscription: Response.data.subscription_expired,
              })
            );
            navigate('/subscription/auth-check');
          }
        }
      } catch (err) {
        setLoading(false);

        if (err?.response?.data?.error) {
          setapiOpen(true);
          setapierrorMsg(err?.response?.data?.error);
        }
        console.log(err);
      }
    }
  };

  const CheckUserTokenExists = () => {
    if (
      esodata.usertoken.value.eso_user_token !== undefined &&
      esodata.usertoken.value.eso_user_token !== null &&
      esodata.usertoken.value.eso_user_token !== ""
    ) {
      navigate("/");
    }
    let eso_user_token = localStorage.getItem('eso_user_token');
    if (eso_user_token) {
      navigate("/");
    }
  };

  const LoadCookieData = () => {
    var CookieEmail = localStorage.getItem("logincookieemail");
    var CookiePass = localStorage.getItem("logincookiepass");
    var CookieStatus = localStorage.getItem("logincookiestatus");
    var Obj = {};
    if (CookieEmail !== null && CookieEmail !== "") {
      Obj["emailPhonelgn"] = CookieEmail;
    }
    if (CookiePass !== null && CookiePass !== "") {
      Obj["passwordlgn"] = CookiePass;
    }
    setFormData(Obj);
    if (CookieStatus !== null && CookieStatus !== "") {
      if (CookieStatus == "true") {
        const checkbox = document.getElementById("remember_me_id");
        if (checkbox) {
          checkbox.checked = true;
        }
        SetRememberMe(true);
      }
    }
  };

  useEffect(() => {
    let eso_user_token = localStorage.getItem('eso_user_token');
    let eso_auth_token = localStorage.getItem('eso_auth_token');
    if (!eso_user_token && !eso_auth_token) {
      localStorage.setItem('header_selected', '');
      localStorage.setItem('verification_method', '');
    }
    setFormData({
      emailPhone: "",
      password: "",
      emailPhonelgn: "",
      passwordlgn: "",
    })
    CheckUserTokenExists();
    LoadCookieData();
    // const handlePageShow = (event) => {
    //   if (event.persisted) {
    //     setFormData({
    //       emailPhone: "",
    //       password: "",
    //       emailPhonelgn: "",
    //       passwordlgn: "",
    //     })
    //   }
    // };

    // window.addEventListener('pageshow', handlePageShow);
    // return () => {
    //   window.removeEventListener('pageshow', handlePageShow);
    // };
  }, []);

  const [value, setValue] = useState(1);

  const handleChange = (newValue) => {
    console.log(newValue)
    if (newValue == "1") {
      var IntialAobj = formData;
      var emailPhonelgnIn = "";
      var passwordlgnIn = "";

      if (IntialAobj.emailPhonelgn) {
        emailPhonelgnIn = IntialAobj.emailPhonelgn;
      }
      if (IntialAobj.passwordlgn) {
        passwordlgnIn = IntialAobj.passwordlgn;
      }
      setFormData({
        emailPhonelgn: emailPhonelgnIn,
        passwordlgn: passwordlgnIn,
        fullname: "",
        emailaddress: "",
        password: "",
      });
    }
    setValue(newValue);
  };

  const [guser, setgUser] = useState([]);

  const glogin = useGoogleLogin({

    onSuccess: (codeResponse) => {
      axios
        .get(
          `https://www.googleapis.com/oauth2/v1/userinfo?access_token=${codeResponse.access_token}`,
          {
            headers: {
              Authorization: `Bearer ${codeResponse.access_token}`,
              Accept: "application/json",
            },
          }
        )
        .then((res) => {
          // SingUpOrLogInwithgoogle("login", res);
          checkExistUser(res, "google");
        })
        .catch((error) => {
          setLoading(false);
          if (
            error?.response?.status == 599 ||
            error?.response?.status == 500 ||
            error?.response?.status == 400 ||
            error?.response?.status == 404
          ) {
            setapiOpen(true);
            setapierrorMsg(error?.response?.data?.error);
          } else if (error?.code == "ERR_NETWORK") {
            navigate("/login-errorpages");
          } else if (error?.response?.data?.status == "invalid") {
            navigate("/business-mobile");
          }
        });
    },
    onError: (error) => console.log("Login Failed:", error),
    redirect_uri: process.env.REACT_APP_GOOGLE_LOGIN_URL,
  });

  const glogins = useGoogleLogin({
    onSuccess: (codeResponse) => {
      axios
        .get(
          `https://www.googleapis.com/oauth2/v1/userinfo?access_token=${codeResponse.access_token}`,
          {
            headers: {
              Authorization: `Bearer ${codeResponse.access_token}`,
              Accept: "application/json",
            },
          }
        )
        .then((res) => {
          // SingUpOrLogInwithgoogle("sign_up", res);
          // var datas = {
          //   name: res.data.name,
          //   email: res.data.email,
          //   type: "google",
          // };

          // navigate('/business-mobile', {
          //   state: {
          //     name: res.data.name,
          //     email: res.data.email,
          //     type: "google",
          //   }
          // });

          checkExistUser(res, "google");
        })
        .catch((error) => {
          setLoading(false);
          if (
            error?.response?.status == 599 ||
            error?.response?.status == 500 ||
            error?.response?.status == 400 ||
            error?.response?.status == 404
          ) {
            setapiOpen(true);
            setapierrorMsg(error?.response?.data?.error);
          } else if (error?.code == "ERR_NETWORK") {
            navigate("/login-errorpages");
          }
        });
    },
    onError: (error) => console.log("Login Failed:", error),
    redirect_uri: process.env.REACT_APP_GOOGLE_LOGIN_URL,

  });

  const SingUpOrLogInwithgoogle = async (action = "", res = "", loginType) => {
    setLoading(true);
    var datas = {
      // name: res.data.name,
      email: res.data.email,
      type: loginType,
    };

    if (res.data.name !== '') {
      datas['name'] = res.data.name;
    }

    const jwt_datas = sign(datas, "VdM1t3n0NiD_Qsawq7ZX");
    try {
      const response = await axios
        .post(
          `${process.env.REACT_APP_API_URL}accounts/save_social_login_data/`,
          { data: jwt_datas }
        )
        .catch((error) => {
          setLoading(false);
          if (
            error?.response?.status == 599 ||
            error?.response?.status == 500 ||
            error?.response?.status == 400 ||
            error?.response?.status == 404
          ) {
            setapiOpen(true);
            setapierrorMsg(error?.response?.data?.error);
          } else if (error?.code == "ERR_NETWORK") {
            navigate("/login-errorpages");
          } else if (error?.response?.data?.status == "invalid") {
            navigate("/business-mobile");
          }
        });
      if (response?.data?.token) {
        dispatch(SetUserToken({ eso_user_token: response.data.token }));
        dispatch(
          SetAuthToken({ eso_auth_token: "Token " + response.data.token })
        );
        window.location.href = `${process.env.REACT_APP_DOMAIN}`;
        // navigate(process.env.REACT_APP_DOMAIN);
      }
    } catch (err) {
      setLoading(false);
      toast.error(err.response.data.error, {
        position: "top-center",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
      });
    }
    setLoading(false);
  };

  const checkExistUser = async (res = "", loginType) => {
    setLoading(true);

    try {
      const response = await axios
        .get(
          `${process.env.REACT_APP_API_URL}accounts/is_user_exists/?email=${res.data.email}`
        )
        .catch((error) => {
          setLoading(false);
          if (
            error?.response?.status == 599 ||
            error?.response?.status == 500 ||
            error?.response?.status == 400 ||
            error?.response?.status == 404
          ) {
            setapiOpen(true);
            setapierrorMsg(error?.response?.data?.error);
          } else if (error?.code == "ERR_NETWORK") {
            navigate("/login-errorpages");
          }
        });
      console.log('response.status', response.data.status)
      if (response.data.status) {
        SingUpOrLogInwithgoogle("login", res, loginType);
      } else {
        navigate('/business-mobile', {
          state: {
            name: res.data.name,
            email: res.data.email,
            type: loginType,
          }
        });
      }
    } catch (err) {
      setLoading(false);
      toast.error(err.response.data.error, {
        position: "top-center",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
      });
    }
    setLoading(false);
  };

  const loginApple = (e) => {
    if (appledatavalue == 1) {
      Setappledatavalue(2);
      if (!e.user) {
        const idToken = jwtDecode(e.authorization?.id_token);
        var data = {
          name: '',
          email: idToken.email,
          type: "apple",
        };
      } else {
        var data = {
          name: e.user.name.firstName + e.user.name.lastName,
          email: e.user.email,
          type: "apple",
        };
      }
      checkExistUser({ data }, 'apple');
    }
  }

  useEffect(() => {
    if (window.location.search) {
      const params = new URLSearchParams(window.location.search);
      const code = params.get('code');
      if (code) {
        glogin({ code });
      }
    }
  }, [glogin]);

  const TriggerEmailOtp = async (token) => {
    try {
      const Response = await axios
        .get(
          `${process.env.REACT_APP_API_URL}accounts/verify_user_email_send_otp/`,

          {
            headers: {
              Authorization: `Token ${token}`,
            },
          }
        )
        .catch((error) => {
          setLoading(false);
          if (
            error?.response?.status == 599 ||
            error?.response?.status == 500 ||
            error?.response?.status == 400 ||
            error?.response?.status == 404
          ) {
            setapiOpen(true);
            setapierrorMsg(error?.response?.data?.error);
          } else if (error?.code == "ERR_NETWORK") {
            navigate("/login-errorpages");
          }
        });
    } catch (error) {
      setapiOpen(true);
      setapierrorMsg(error?.response?.data?.error);
    }
  };

  // useEffect(() => {
  //   // Fully clear autofill & state
  //   setFormData({
  //     emailPhonelgn: "",
  //     passwordlgn: "",
  //   });

  //   if (emailPhonelgnRef.current) emailPhonelgnRef.current.value = "";
  //   if (passwordlgnRef.current) passwordlgnRef.current.value = "";
  // }, []);

  // useEffect(() => {
  //   setTimeout(() => {
  //     setFormData({
  //       emailPhonelgn: emailPhonelgnRef.current?.value || "",
  //       passwordlgn: passwordlgnRef.current?.value || "",
  //     });
  //   }, 3000); // let autofill finish
  // }, []);

  // useEffect(() => {
  //   if (localStorage.getItem("eso_user_token")) {
  //     window.location.replace("/"); // or your actual home path
  //   }
  // }, []);

  // useEffect(() => {
  //   const token = localStorage.getItem("eso_user_token");
  //   if (token) {
  //     navigate("/", { replace: true });
  //   }
  // }, []);

  const tabData = [


    {
      title: <div className="tab_head_container">Log in</div>,
      content: (
        <div className="tab_head_container_outr">
          <div className="frm_otr_wrap">
            <div className="frm_inner_wrap">
              <form
                onSubmit={loginSubmit}
                className="frm_container"
                method="post"
              >
                <div className="form-group email_grp">
                  <input
                    type="text"
                    id="email_Phone"
                    className="newform_val"
                    name="emailPhonelgn"
                    placeholder="Email address"
                    // autoComplete="new-email"
                    value={formData.emailPhonelgn}
                    onChange={SmthandleChangelgn}
                    ref={emailPhonelgnRef}
                  />
                  <div className="frm_error">{errors.emailPhonelgn}</div>
                </div>
                <div className="form-group">
                  <input
                    type={showPasswordlgn ? "text" : "password"}
                    id="password"
                    name="passwordlgn"
                    className="newform_val"
                    placeholder="Password"
                    // autoComplete="new-email"
                    value={formData.passwordlgn}
                    onChange={SmthandleChangelgn}
                    ref={passwordlgnRef}
                  />
                  <button
                    type="button"
                    className="toggle-password"
                    onClick={handleTogglePasswordlgn}
                  >
                    {showPasswordlgn ? (
                      <FaEye className="FaEy" />
                    ) : (
                      <FaEyeSlash className="FaEyeSlash" />
                    )}
                  </button>
                </div>
                <div className="frm_error">{errors.passwordlgn}</div>

                <div className="forgot_remember_row">
                  <span className="forgot-password">

                  </span>
                  <a href="/password-reset" className="forgot-password">
                    Forgot Password?
                  </a>
                </div>

                <button type="submit" className="sbt_btn">
                  Login
                </button>
              </form>
            </div>
          </div>
          <div className="tab_link_outr_wrap">
            <a href="#0" onClick={() => glogin()}>
              Login in with
              <span>
                {" "}
                <img src={GoogleLogo} alt="google Logo" />
              </span>
            </a>
            <a href="#0" className="apple_login_outer">
              Login in with

              <span style={{ marginLeft: "5px" }}>
                {" "}
                <AppleLogin
                  clientId={process.env.REACT_APP_APPLE_LOGIN_CLIENT_ID}
                  redirectURI={process.env.REACT_APP_APPLE_LOGIN_REDIRECT_PATH}
                  usePopup={true}
                  callback={appleResponse}
                  responseType={"code"}
                  scope="name email"
                  responseMode="query"
                  render={(
                    renderProps
                  ) => (
                    <button
                      className="apple-sign-in"
                      onClick={renderProps.onClick}
                    ></button>
                  )}
                />
                <AppleIcon />
              </span>
            </a>
          </div>
        </div>
      ),
      image: (
        <img src={LoginImage} alt="left image" className="login_lft_img" />
      ),
      tabId: "lgn-tab-container",
    },
    {
      title: <div className="tab_head_container">Sign up</div>,
      content: (
        <div className="tab_head_container_outr">

          <div className="frm_otr_wrap">
            <div className="frm_inner_wrap">
              <form
                onSubmit={handleSubmit}
                className="frm_container"
                method="post"
              >
                <div className="form-group email_grp">
                  <input
                    type="text"
                    id="email_Phone"
                    className="newform_val"
                    name="fullname"
                    autoComplete="off"
                    placeholder="Full name"
                    value={formData.fullname}
                    defaultValue={formData.fullname}
                    onChange={SmthandleChange}
                    ref={fullnameRef}
                  />
                  <div className="frm_error">{errors.fullname}</div>
                </div>
                <div className="form-group email_grp">
                  <input
                    type="text"
                    id="email_Phone"
                    className="newform_val"
                    name="emailaddress"
                    autoComplete="off"
                    placeholder="Email address"
                    value={formData.emailaddress}
                    defaultValue={formData.emailaddress}
                    onChange={SmthandleChange}
                    ref={emailPhoneRef}
                  />
                  <div className="frm_error">{errors.emailaddress}</div>
                </div>
                <div className="form-group email_grp">
                  {/* <input
                    type="text"
                    id="email_Phone"
                    className="newform_val"
                    name="mobile"
                    autoComplete="off"
                    placeholder="Mobile No."
                    value={formData.mobile}
                    defaultValue={formData.mobile}
                    onChange={SmthandleChange}
                    ref={mobileRef}
                  /> */}

                  <PhoneInput
                    id="email_Phone"
                    name='mobile'
                    country={'us'}
                    enableSearch={true}
                    value={formData.mobile || ''}
                    onChange={handlePhoneChange}
                    preferredCountries={['us', 'in']}
                    inputClass="custom-phone-input"
                    specialLabel=""
                    placeholder=""
                    ref={mobileRef}
                    inputProps={{
                      maxLength: 40 // Increase length if needed
                    }}
                    enableLongNumbers={true}
                  />

                  <div className="frm_error">{mobileErr}</div>
                </div>
                <div className="form-group email_grp">
                  <input
                    type="text"
                    id="email_Phone"
                    className="newform_val"
                    name="business"
                    autoComplete="off"
                    placeholder="Business name"
                    value={formData.business}
                    defaultValue={formData.business}
                    onChange={SmthandleChange}
                    ref={businessRef}
                  />
                  <div className="frm_error">{errors.business}</div>
                </div>

                <div className="form-group pass_field_grp">
                  <input
                    type={showPasswordreg ? "text" : "password"}
                    id="password"
                    name="password"
                    className="newform_val sgn_pswd"
                    autoComplete="off"
                    placeholder="Password"
                    onChange={SmthandleChange}
                    ref={passwordRef}
                  />
                  <button
                    type="button"
                    className="toggle-password"
                    onClick={handleTogglePasswordreg}
                  >
                    {showPasswordreg ? (
                      <FaEye className="FaEy" />
                    ) : (
                      <FaEyeSlash className="FaEyeSlash" />
                    )}
                  </button>
                  <div className="frm_error">{errors.password}</div>
                </div>
                <div className="form-group pass_field_grp">
                  <input
                    type={showCPasswordreg ? "text" : "password"}
                    id="password"
                    name="confirmpassword"
                    className="newform_val sgn_pswd"
                    autoComplete="off"
                    placeholder="Confirm Password"
                    onChange={SmthandleChange}
                    ref={confirmpasswordRef}
                  />
                  <button
                    type="button"
                    className="toggle-password"
                    onClick={handlecTogglePasswordreg}
                  >
                    {showCPasswordreg ? (
                      <FaEye className="FaEy" />
                    ) : (
                      <FaEyeSlash className="FaEyeSlash" />
                    )}
                  </button>
                  <div className="frm_error">{errors.Confirmpassword}</div>
                </div>
                <div className="form-group register_term_accept">
                  <input
                    type="checkbox"
                    value={AcceptMe}
                    onChange={(e) => {
                      SetAcceptMe(e.target.checked);
                    }}
                  />
                  <span>
                    Click here to agree to the Terms & Conditions. By creating your account, you agree to the{" "}
                    <a
                      href="https://www.elitesiteoptimizer.com/terms-and-conditions/"
                      target="_blank"
                    >
                      Terms of Service
                    </a>{" "}
                    and{" "}
                    <a
                      href="https://www.elitesiteoptimizer.com/privacy-policy/"
                      target="_blank"
                    >
                      Privacy Policy.
                    </a>
                  </span>
                  <div className="frm_error">{errors.acceptme}</div>
                </div>

                <button type="submit" className="sbt_btn crt_act">
                  Create account
                </button>
              </form>
            </div>
          </div>
          <div className="tab_link_outr_wrap">
            <a href="#0" onClick={() => glogins()}>
              Sign up with
              <span>
                {" "}
                <img src={GoogleLogo} alt="google Logo" />
              </span>
            </a>
            <a href="#0" className="apple_login_outer">
              Sign up with
              <span>
                {" "}
                <AppleLogin
                  clientId={process.env.REACT_APP_APPLE_LOGIN_CLIENT_ID}
                  redirectURI={process.env.REACT_APP_APPLE_LOGIN_REDIRECT_PATH}
                  usePopup={true}
                  callback={appleResponse}
                  responseType={"code"}
                  scope="name email"
                  responseMode="query"
                  render={(
                    renderProps
                  ) => (
                    <button
                      className="apple-sign-in"
                      onClick={renderProps.onClick}
                    ></button>
                  )}
                />
                <AppleIcon />
              </span>
            </a>
          </div>
        </div>
      ),
      image: (
        <img src={RegisterImage} className="RegisterImage" alt="left image" />
      ),
      tabId: "sgn-tab-container",
    },
  ];

  const tab1ref = useRef(null);


  const slidesData = [
    {
      img: sliderImg,
      title: "SEO is not a cost",
      desc: "It’s the most powerful investment in your brand’s future. It’s the most powerful investment.",
    },
    {
      img: sliderImg,
      title: "SEO is not a cost",
      desc: "It’s the most powerful investment in your brand’s future. It’s the most powerful investment.",
    },
  ];

  const [currentIndex, setCurrentIndex] = useState(0);
  const totalSlides = slidesData.length;
  const timerRef = useRef(null);

  const goToSlide = (index) => {
    setCurrentIndex(index);
  };

  useEffect(() => {
    startAutoSlide();
    return () => stopAutoSlide(); // cleanup on unmount
  }, []);

  const startAutoSlide = () => {
    stopAutoSlide();
    timerRef.current = setInterval(() => {
      setCurrentIndex((prev) => (prev + 1) % totalSlides);
    }, 6000);
  };

  const stopAutoSlide = () => {
    if (timerRef.current) clearInterval(timerRef.current);
  };

  const [currentStep, setCurrentStep] = useState(0);

  const handleNext = () => {
    checkStep1();
  };

  const checkStep1 = () => {
    const { emailaddress, password, confirmpassword, username, fullname, mobile, business } =
      formData;
    const phoneNumberRegex = /^[0-9]{10}$/;
    const emailRegex = /^[a-zA-Z0-9._-]+@[a-zA-Z][a-zA-Z0-9.-]*\.[a-zA-Z]{2,}$/;
    const newErrors = {};
    if (!emailaddress || emailaddress.length === 0) {
      newErrors.emailaddress = "Please enter your Email address";
      emailPhoneRef.current.focus();
    } else if (!emailRegex.test(emailaddress)) {
      newErrors.emailaddress = "Invalid Email Address";
      emailPhoneRef.current.focus();
    }
    if (!password) {
      newErrors.password = "Please enter your Password";
      passwordRef.current.focus();
    }
    if (password) {
      if (testPasswordStrength(password) === false) {
        newErrors.password =
          "Password does not meet the criteria. It should contain at least one uppercase letter, one digit, and one special character (@, $, !, %, *, ?, &), and be at least 8 characters long";
        passwordRef.current.focus();
      }
    }
    if (!confirmpassword) {
      newErrors.Confirmpassword = "Please enter Confirm Password";
      confirmpasswordRef.current.focus();
    }
    if (
      confirmpassword &&
      password &&
      testPasswordStrength(password) !== false
    ) {
      if (confirmpassword != password)
        newErrors.Confirmpassword =
          "Password and Confirm password should be same";
      confirmpasswordRef.current.focus();
    }
    if (!fullname) {
      newErrors.fullname = "Please enter your Full Name";
      fullnameRef.current.focus();
    }
    setErrors(newErrors);
    if (newErrors.emailPhone) {
      emailPhoneRef.current.focus();
    } else if (newErrors.password) {
      passwordRef.current.focus();
    } else if (newErrors.username) {
      usernameRef.current.focus();
    } else if (newErrors.fullname) {
      fullnameRef.current.focus();
    }
    console.log('newErrors', newErrors);
    if (isObjectEmpty(newErrors)) {
      setCurrentStep((prev) => prev + 1);
    }
  }

  const handlePrev = () => {
    setCurrentStep((prev) => prev - 1);
  };

  const handleSubmit1 = (e) => {
    e.preventDefault();
    alert("Form submitted!");
  };



  return (
    <>
      <Helmet>
        <meta charSet="utf-8" />
        <title>Sign Up For Elite Site Optimizer</title>
      </Helmet>
      {loading === true ? <Loader /> : null}
      <ToastContainer
        position="top-center"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="light"
      />
      {/* <div
        style={{
          width: "calc(100% - 60px)",
          marginRight: "60px",
          marginLeft: "auto",
          marginRight: "auto",
        }}
      >
        <div className="tab_otr_outer lgn_container new_tab_otr_outer">
          <div className="tab_head_container_lft newlogin">
            <div className="login_tab_img_outer">
              <img
                src={Logo}
                className="login_tab_img dataimg"
                alt="ESO logo"
              />
            </div>
            <Box
              sx={{
                maxWidth: { xs: 768, sm: 475 },
                bgcolor: "background.paper",
              }}
            >
              <div className="tab-header">
                <Tabs
                  value={value}
                  onChange={handleChange}
                  variant="scrollable"
                  scrollButtons
                  allowScrollButtonsMobile
                  aria-label="scrollable force tabs example"
                  className="signallbutton"
                >
                  <Tab
                    ref={tab1ref}
                    key={1}
                    label={"Login"}
                    className="signbutton"
                  />
                  <Tab key={2} label={"SignUp"} className="signbutton" />
                </Tabs>
              </div>
              <div className="das_tab_container">{tabData[value].content}</div>
            </Box>
          </div>
        </div>
      </div> */}

      {/* <div className="floating-shapes">
        <div className="shape shape-1"></div>
        <div className="shape shape-2"></div>
      </div> */}



      <div className="login-container">
        <div className="container">
          <div className="row justify-content-center form-side login-index">
            <div className="col-12 col-md-5 col-xl-5 login-width-100">
              <div className="p-lg-5 p-4 sign-box-shodow sign-box">
                <h4 className="index-header" style={{ marginTop: "0px" }}>Sign Up For Elite Site Optimizer</h4>
                {/* Social Buttons */}
                <div className="d-flex mb-3" style={{ gap: "20px" }}>
                  <button
                    type="button"
                    className="social-btn"
                    onClick={glogin}
                  >
                    <img className="social-icon google-icon" src={GoogleLogo} alt="Google" />
                    Google
                  </button>
                  <AppleLogin
                    clientId={process.env.REACT_APP_APPLE_LOGIN_CLIENT_ID}
                    redirectURI={process.env.REACT_APP_APPLE_LOGIN_REDIRECT_PATH}
                    usePopup={true}
                    // callback={appleResponse}
                    callback={loginApple}
                    responseType={"code"}
                    scope="name email"
                    responseMode="query"
                    render={(renderProps) => (
                      <button
                        type="button"
                        className="social-btn 9"
                        onClick={renderProps.onClick}
                      >
                        <svg className="social-icon apple-icon" viewBox="0 0 24 24">
                          <path d="M16.365 1.43c0 1.14-.45 2.17-1.15 2.89-.72.74-1.8 1.3-2.92 1.14-.15-1.08.3-2.2 1.04-2.97C14.09 1.64 15.24 1.11 16.365 1.43zM20.1 17.17c-.47 1.08-.7 1.56-1.3 2.5-.85 1.28-2.05 2.88-3.56 2.9-1.4.02-1.84-.94-3.44-.92-1.6.02-2.08.94-3.48.92-1.52-.02-2.68-1.44-3.53-2.71C3.4 17.73 1.83 13.07 3.9 9.82c.95-1.55 2.63-2.54 4.45-2.57 1.4-.03 2.7.95 3.48.95.76 0 2.3-1.16 3.88-.99.66.03 2.5.27 3.68 2.05-3.2 1.76-2.69 6.37.68 7.91z" />
                        </svg>
                        Apple
                      </button>
                    )}
                  />
                </div>
                <div className="form-wrapper">
                  <form>
                    {/* Step 1 */}
                    {currentStep === 0 && (
                      <div className="form-step active">
                        <div className="form-group mb-3">
                          <input
                            type="text"
                            id="name"
                            className="form-control form-input"
                            placeholder=" "
                            name="fullname"
                            autoComplete="off"
                            value={formData.fullname}
                            defaultValue={formData.fullname}
                            onChange={SmthandleChange}
                            ref={fullnameRef}
                            required
                          />
                          <label htmlFor="name" className="form-label">
                            Full Name
                          </label>
                          <div className="frm_error">{errors.fullname}</div>
                        </div>
                        <div className="form-group mb-3">
                          <input
                            type="email"
                            id="email"
                            className="form-control form-input"
                            placeholder=" "
                            name="emailaddress"
                            autoComplete="off"
                            value={formData.emailaddress}
                            defaultValue={formData.emailaddress}
                            onChange={SmthandleChange}
                            ref={emailPhoneRef}
                            required
                          />
                          <label htmlFor="email" className="form-label">
                            Email
                          </label>
                          <div className="frm_error">{errors.emailaddress}</div>
                        </div>

                        <div className="form-group" style={{ marginBottom: "0px" }}>
                          <input
                            type={showPasswordreg ? "text" : "password"}
                            id="passwordInput"
                            name="password"
                            value={formData.password}
                            onChange={SmthandleChange}
                            ref={passwordRef}
                            className="form-control form-input"
                            placeholder=""
                          />
                          <label htmlFor="passwordInput" className="form-label">Password</label>

                          <span
                            className="password-toggle"
                            onClick={() => setShowPasswordreg(!showPasswordreg)}
                            style={{ cursor: "pointer" }}
                          >
                            {showPasswordreg ? (
                              // Eye-slash icon
                              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 576 512" height="1em" width="1em" fill="currentColor">
                                <path d="M572.52 241.4C518.41 135.1 411.35 64 288 64 164.65 64 57.59 135.1 3.48 241.4a48.03 48.03 0 0 0 0 29.2C57.59 376.9 164.65 448 288 448c123.35 0 230.41-71.1 284.52-177.4a48.03 48.03 0 0 0 0-29.2zM288 400c-79.4 0-144-64.6-144-144S208.6 112 288 112s144 64.6 144 144-64.6 144-144 144zm0-240a96 96 0 1 0 96 96 96.11 96.11 0 0 0-96-96z" />
                              </svg>

                            ) : (
                              // Eye icon
                              <svg
                                stroke="currentColor"
                                fill="currentColor"
                                strokeWidth="0"
                                viewBox="0 0 640 512"
                                height="1em"
                                width="1em"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path d="M320 400c-75.85 0-137.25-58.71-142.9-133.11L72.2 185.82c-13.79 17.3-26.48 35.59-36.72 55.59a32.35 32.35 0 0 0 0 29.19C89.71 376.41 197.07 448 320 448c26.91 0 52.87-4 77.89-10.46L346 397.39a144.13 144.13 0 0 1-26 2.61zm313.82 58.1l-110.55-85.44a331.25 331.25 0 0 0 81.25-102.07 32.35 32.35 0 0 0 0-29.19C550.29 135.59 442.93 64 320 64a308.15 308.15 0 0 0-147.32 37.7L45.46 3.37A16 16 0 0 0 23 6.18L3.37 31.45A16 16 0 0 0 6.18 53.9l588.36 454.73a16 16 0 0 0 22.46-2.81l19.64-25.27a16 16 0 0 0-2.82-22.45zm-183.72-142l-39.3-30.38A94.75 94.75 0 0 0 416 256a94.76 94.76 0 0 0-121.31-92.21A47.65 47.65 0 0 1 304 192a46.64 46.64 0 0 1-1.54 10l-73.61-56.89A142.31 142.31 0 0 1 320 112a143.92 143.92 0 0 1 144 144c0 21.63-5.29 41.79-13.9 60.11z"></path>
                              </svg>
                            )}
                          </span>
                        </div>
                        <div className="frm_error mb-3">{errors.password}</div>
                        <div className="form-group" style={{ marginBottom: "0px" }}>
                          <input
                            type={showCPasswordreg ? "text" : "password"}
                            id="confirmPassword"
                            name="confirmpassword"
                            autoComplete="off"
                            onChange={SmthandleChange}
                            ref={confirmpasswordRef}
                            className="form-control form-input"
                            placeholder=""
                          />
                          <label htmlFor="confirmPassword" className="form-label">Confirm Password</label>

                          <span
                            className="password-toggle"
                            onClick={() => setShowCPasswordreg(!showCPasswordreg)}
                            style={{ cursor: "pointer" }}
                          >
                            {showCPasswordreg ? (
                              // Eye-slash icon
                              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 576 512" height="1em" width="1em" fill="currentColor">
                                <path d="M572.52 241.4C518.41 135.1 411.35 64 288 64 164.65 64 57.59 135.1 3.48 241.4a48.03 48.03 0 0 0 0 29.2C57.59 376.9 164.65 448 288 448c123.35 0 230.41-71.1 284.52-177.4a48.03 48.03 0 0 0 0-29.2zM288 400c-79.4 0-144-64.6-144-144S208.6 112 288 112s144 64.6 144 144-64.6 144-144 144zm0-240a96 96 0 1 0 96 96 96.11 96.11 0 0 0-96-96z" />
                              </svg>

                            ) : (
                              // Eye icon
                              <svg
                                stroke="currentColor"
                                fill="currentColor"
                                strokeWidth="0"
                                viewBox="0 0 640 512"
                                height="1em"
                                width="1em"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path d="M320 400c-75.85 0-137.25-58.71-142.9-133.11L72.2 185.82c-13.79 17.3-26.48 35.59-36.72 55.59a32.35 32.35 0 0 0 0 29.19C89.71 376.41 197.07 448 320 448c26.91 0 52.87-4 77.89-10.46L346 397.39a144.13 144.13 0 0 1-26 2.61zm313.82 58.1l-110.55-85.44a331.25 331.25 0 0 0 81.25-102.07 32.35 32.35 0 0 0 0-29.19C550.29 135.59 442.93 64 320 64a308.15 308.15 0 0 0-147.32 37.7L45.46 3.37A16 16 0 0 0 23 6.18L3.37 31.45A16 16 0 0 0 6.18 53.9l588.36 454.73a16 16 0 0 0 22.46-2.81l19.64-25.27a16 16 0 0 0-2.82-22.45zm-183.72-142l-39.3-30.38A94.75 94.75 0 0 0 416 256a94.76 94.76 0 0 0-121.31-92.21A47.65 47.65 0 0 1 304 192a46.64 46.64 0 0 1-1.54 10l-73.61-56.89A142.31 142.31 0 0 1 320 112a143.92 143.92 0 0 1 144 144c0 21.63-5.29 41.79-13.9 60.11z"></path>
                              </svg>
                            )}
                          </span>
                        </div>
                        <div className="frm_error mb-3">{errors.Confirmpassword}</div>
                        {/* <div className="form-group mb-3">
                        <input
                          type="password"
                          id="password"
                          className="form-control form-input"
                          placeholder=""
                          name="password"
                          autoComplete="off"
                          onChange={SmthandleChange}
                          ref={passwordRef}
                        />
                        <label htmlFor="password" className="form-label">
                          Password
                        </label>
                        <div className="frm_error">{errors.password}</div>
                      </div> */}
                        {/* <div className="form-group mb-3">
                        <input
                          type="password"
                          id="confirmPassword"
                          className="form-control form-input"
                          placeholder=""
                          name="confirmpassword"
                          autoComplete="off"
                          onChange={SmthandleChange}
                          ref={confirmpasswordRef}
                        />
                        <label htmlFor="confirmPassword" className="form-label">
                          Confirm Password
                        </label>
                        <div className="frm_error">{errors.Confirmpassword}</div>
                      </div> */}
                        <button
                          type="button"
                          className="btn btn-submit w-100"
                          onClick={handleNext}
                        >
                          Next
                        </button>
                      </div>
                    )}

                    {/* Step 2 */}
                    {currentStep === 1 && (
                      <div className="form-step active">
                        {/* <div className="form-group mb-3">
                        <input
                          type="text"
                          id="number"
                          className="form-control form-input"
                          placeholder=" "
                          required
                        />
                        <label htmlFor="number" className="form-label">
                          Number
                        </label>
                        <div className="frm_error">{mobileErr}</div>
                      </div> */}
                        <div className="mb-3">
                          {/* <label for="registerEmail" className="form-label">Phone Number</label> */}
                          <PhoneInput
                            id="email_Phone"
                            className="phn-signup"
                            name='mobile'
                            country={'us'}
                            enableSearch={true}
                            value={formData.mobile || ''}
                            onChange={handlePhoneChange}
                            preferredCountries={['us', 'in']}
                            inputClass="custom-phone-input"
                            specialLabel=""
                            placeholder=""
                            ref={mobileRef}
                            inputProps={{
                              maxLength: 40
                            }}
                            enableLongNumbers={true}
                          />
                          <div className="frm_error">{mobileErr}</div>
                        </div>
                        <div className="form-group mb-3">
                          <input
                            type="text"
                            id="businessName"
                            className="form-control form-input"
                            placeholder=" "
                            name="business"
                            autoComplete="off"
                            value={formData.business}
                            defaultValue={formData.business}
                            onChange={SmthandleChange}
                            ref={businessRef}
                            required
                          />
                          <label htmlFor="businessName" className="form-label">
                            Business Name
                          </label>
                          <div className="frm_error">{errors.business}</div>
                        </div>
                        <div className="form-check mb-3">
                          <input
                            className="form-check-input"
                            type="checkbox"
                            id="terms"
                            value={AcceptMe}
                            onChange={(e) => {
                              SetAcceptMe(e.target.checked);
                            }}
                            required
                          />
                          <label className="form-check-label" htmlFor="terms">
                            <span className="checkbox-text">
                              I agree to the Terms of Service & Privacy Policy.
                            </span>
                            <div className="frm_error">{errors.acceptme}</div>
                          </label>
                        </div>
                        <div>
                          <button type="submit" className="btn btn-submit w-100" onClick={handleSubmit}>
                            Create account
                          </button>
                          <button
                            type="button"
                            className="btn btn-back mt-2"
                            onClick={handlePrev}
                          >
                            Back
                          </button>
                        </div>
                      </div>
                    )}
                  </form>
                </div>

                <div className="sign-up-footer">
                  <div className="text-center loign-account">
                    Already have an account?{" "}
                    <a href="/login" className="" style={{ color: "rgb(255, 96, 31)" }}>
                      Log in
                    </a>
                  </div>
                </div>
              </div>

              <div className="bottom-text">
                <p style={{ textAlign: "center" }}>
                  All Rights Reserved Copyright © 2026 |
                  <span className="login-text"> Elite site Optimizer</span>
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>





      {/* <div className="container">
        <div className="auth-container mx-auto">
          <div className="auth-header">
            <img src={ESOLogo} alt="ELITE SITE OPTIMIZER" className="logo-img" />
          </div>

          <div className="auth-body">
            <ul className="nav nav-tabs nav-justified mb-4" id="authTab" role="tablist">
              <li className="nav-item" role="presentation" onClick={() => handleChange(1)}>
                <button className={`nav-link ${value === 1 ? "active" : ""}`} id="login-tab" data-bs-toggle="tab" data-bs-target="#login" type="button" role="tab">Login</button>
              </li>
              <li className="nav-item" role="presentation" onClick={() => handleChange(2)}>
                <button className={`nav-link ${value === 2 ? "active" : ""}`} id="register-tab" data-bs-toggle="tab" data-bs-target="#register" type="button" role="tab">Register</button>
              </li>
            </ul>

            <div className="tab-content" id="authTabContent">
              {value === 1 &&
                <div className="tab-pane fade show active" id="login" role="tabpanel">
                  <form>
                    <div className="mb-3">
                      <label for="loginEmail" className="form-label">Email Address 1</label>
                      <input
                        type="text"
                        className="form-control"
                        id="loginEmail"
                        name="emailPhonelgn"
                        placeholder="Enter your email"
                        value={formData.emailPhonelgn}
                        onChange={SmthandleChangelgn}
                        ref={emailPhonelgnRef}
                      />
                      <div className="frm_error">{errors.emailPhonelgn}</div>
                    </div>

                    <div className="mb-3">
                      <label
                        for="loginPassword" className="form-label">Password</label>
                      <input
                        type="password"
                        className="form-control"
                        id="loginPassword"
                        name="passwordlgn"
                        placeholder="Enter your password"
                        value={formData.passwordlgn}
                        onChange={SmthandleChangelgn}
                        ref={passwordlgnRef}
                      />
                      <div className="frm_error">{errors.passwordlgn}</div>
                    </div>

                    <div className="d-flex justify-content-between align-items-center mb-4">
                      <div className="form-check">
                        
                      </div>
                      <a href="/password-reset" className="forgot-link">Forgot password?</a>
                    </div>

                    <button type="submit" className="btn btn-primary w-100 mb-3" onClick={loginSubmit}>Login</button>

                    <div className="divider">or continue with</div>

                    <div className="social-login row1 g-2">
                      <div className="col-md-6">
                        <button type="button" className="btn w-100" onClick={() => glogin()}>
                          
                          <img src={GoogleLogo} alt="google Logo" style={{ width: "25px", marginRight: "10px" }} />Google
                        </button>
                      </div>
                      <div className="col-md-6">
                        <button type="button" className="btn w-100">
                          <AppleLogin
                            clientId={process.env.REACT_APP_APPLE_LOGIN_CLIENT_ID}
                            redirectURI={process.env.REACT_APP_APPLE_LOGIN_REDIRECT_PATH}
                            usePopup={true}
                            callback={appleResponse}
                            responseType={"code"}
                            scope="name email"
                            responseMode="query"
                            render={(
                              renderProps
                            ) => (
                              <button
                                className="apple-sign-in"
                                onClick={renderProps.onClick}
                              ></button>
                            )}
                          />
                          <AppleIcon style={{ width: "25px", marginRight: "10px" }} /> Apple
                        </button>
                      </div>
                    </div>
                  </form>
                </div>
              }
              {value === 2 &&
                <div className="tab-pane fade" id="register" role="tabpanel">
                  <form>
                    <div className="mb-3">
                      <label for="registerName" className="form-label">Full Name</label>
                      <input
                        type="text"
                        className="form-control"
                        id="registerName"
                        placeholder="Enter your full name"
                        name="fullname"
                        autoComplete="off"
                        value={formData.fullname}
                        defaultValue={formData.fullname}
                        onChange={SmthandleChange}
                        ref={fullnameRef}
                      />
                      <div className="frm_error">{errors.fullname}</div>
                    </div>

                    <div className="mb-3">
                      <label for="registerEmail" className="form-label">Email Address</label>
                      <input
                        type="email"
                        className="form-control"
                        id="registerEmail"
                        placeholder="Enter your email"
                        name="emailaddress"
                        autoComplete="off"
                        value={formData.emailaddress}
                        defaultValue={formData.emailaddress}
                        onChange={SmthandleChange}
                        ref={emailPhoneRef}
                      />
                      <div className="frm_error">{errors.emailaddress}</div>
                    </div>

                    <div className="mb-3">
                      <label for="registerEmail" className="form-label">Phone Number</label>
                      <PhoneInput
                        id="email_Phone"
                        name='mobile'
                        country={'us'}
                        enableSearch={true}
                        value={formData.mobile || ''}
                        onChange={handlePhoneChange}
                        preferredCountries={['us', 'in']}
                        inputClass="custom-phone-input"
                        specialLabel=""
                        placeholder=""
                        ref={mobileRef}
                        inputProps={{
                          maxLength: 40 
                        }}
                        enableLongNumbers={true}
                      />
                      <div className="frm_error">{mobileErr}</div>
                    </div>

                    <div className="mb-3">
                      <label for="registerEmail" className="form-label">Business Name</label>
                      <input
                        type="text"
                        className="form-control"
                        id="registerEmail"
                        placeholder="Enter your email"
                        name="business"
                        autoComplete="off"
                        value={formData.business}
                        defaultValue={formData.business}
                        onChange={SmthandleChange}
                        ref={businessRef}
                      />
                      <div className="frm_error">{errors.business}</div>
                    </div>

                    <div className="mb-3">
                      <label for="registerPassword" className="form-label">Password</label>
                      <input
                        type="password"
                        className="form-control"
                        id="registerPassword"
                        placeholder="Create a password"
                        name="password"
                        autoComplete="off"
                        onChange={SmthandleChange}
                        ref={passwordRef}
                      />
                      <div className="frm_error">{errors.password}</div>
                    </div>

                    <div className="mb-4">
                      <label for="registerConfirmPassword" className="form-label">Confirm Password</label>
                      <input
                        type="password"
                        className="form-control"
                        id="registerConfirmPassword"
                        placeholder="Confirm your password"
                        name="confirmpassword"
                        autoComplete="off"
                        onChange={SmthandleChange}
                        ref={confirmpasswordRef}
                      />
                      <div className="frm_error">{errors.Confirmpassword}</div>
                    </div>

                    <div className="form-group register_term_accept" style={{ display: "block" }}>
                      <input
                        type="checkbox"
                        value={AcceptMe}
                        onChange={(e) => {
                          SetAcceptMe(e.target.checked);
                        }}
                      />
                      <span>
                        Click here to agree to the Terms & Conditions. By creating your account, you agree to the{" "}
                        <a
                          href="https://www.elitesiteoptimizer.com/terms-and-conditions/"
                          target="_blank"
                        >
                          Terms of Service
                        </a>{" "}
                        and{" "}
                        <a
                          href="https://www.elitesiteoptimizer.com/privacy-policy/"
                          target="_blank"
                        >
                          Privacy Policy.
                        </a>
                      </span>
                      <div className="frm_error">{errors.acceptme}</div>
                    </div>

                    <button type="submit" className="btn btn-primary w-100" onClick={handleSubmit}>Create Account</button>
                  </form>
                  <div className="divider">or continue with</div>

                  <div className="social-login row1 g-2">
                    <div className="col-md-6">
                      <button type="button" className="btn w-100" onClick={() => glogins()}>
                       
                        <img src={GoogleLogo} alt="google Logo" style={{ width: "25px", marginRight: "10px" }} />Google
                      </button>
                    </div>
                    <div className="col-md-6">
                      <button type="button" className="btn w-100">
                        <AppleLogin
                          clientId={process.env.REACT_APP_APPLE_LOGIN_CLIENT_ID}
                          redirectURI={process.env.REACT_APP_APPLE_LOGIN_REDIRECT_PATH}
                          usePopup={true}
                          callback={appleResponse}
                          responseType={"code"}
                          scope="name email"
                          responseMode="query"
                          render={(
                            renderProps
                          ) => (
                            <button
                              className="apple-sign-in"
                              onClick={renderProps.onClick}
                            ></button>
                          )}
                        />
                        <AppleIcon style={{ width: "25px", marginRight: "10px" }} /> Apple 1
                      </button>
                    </div>
                  </div>
                </div>
              }
            </div>
          </div>

          <div className="auth-footer">
            <p className="mb-0">Need help?  <a href="mailto:support@elitesiteoptimizer.com">Contact support</a></p>
          </div>
        </div>
      </div> */}
      <CommonErrorAlert
        data={{
          apiopen: apiopen,
          apiErrorMsg: apierrorMsg,
          isIconStyled: true
        }}
        closeAlert={apihandleClose} />
    </>
  );
}
export default Registration;
